var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "error-desc" }, [
      _c("h2", [_vm._v("很抱歉，您要访问的页面不存在")]),
      _vm._v(" "),
      _c("p", [_vm._v("1.您要访问的网页不存在或已被删除")]),
      _vm._v(" "),
      _c("p", [_vm._v("2.请检查您输入的网址是否正确")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n      您可以返回首页"),
        _c("i", [_vm._v(_vm._s(_vm.count))]),
        _vm._v("秒后将自动跳转首页\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "error-header" }, [
      _c("a", {
        staticClass: "btn-back",
        attrs: { href: "javascript:history.go(-1)" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "error-img" }, [
      _c("img", { attrs: { src: require("../../asset/img/404.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }